// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles() {
    return {
        linkContainer: {
            width: '100%',
            textAlign: 'center' as const,
        },
    };
}